import React, { Component } from "react";
import { API_TOKEN_NAME, IMAGE_URL } from "../../../constants";
import { scAxiosAdmin, thirdparty } from "../../..";
import news_events_1 from "../../../images/new2.png";
import Slider from "react-slick";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
import styles from "../../../css/newsEvents.module.css";

const getNewsEvents = () => {
  return new Promise((resolve, reject) => {
    const req = thirdparty.request("/newsevents/getnewsevents", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
class NewsSlides extends Component {
  state = {
    newsEventData: [],
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  refreshGetNewsEventsData = () => {
    getNewsEvents()
      .then((res) => {
        if (res.status === true) {
          var records = res.data.filter((item) => item.type === "News");

          this.setState({
            newsEventData: records,
          });
        } else {
          this.setState({
            newsEventData: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  formatDate(inputDate) {
    const date = new Date(inputDate);

    const day = date.getDate();
    const year = date.getFullYear();

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];

    return {
      date: `${day} ${month} `,
      year: `${month} ${year}`,
    };
  }
  componentDidMount() {
    this.refreshGetNewsEventsData();
  }
  render() {
    let crousel_row_number = "";
    if (this.state.newsEventData.length < 8) {
      crousel_row_number = "1";
    } else {
      crousel_row_number = "2";
    }
    const settings = {
      rows: 1,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const mobileSettings = {
      rows: 1,
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    return (
      <div>
        <section
          style={{ backgroundColor: "#F7F5EF" }}
          className="news-events pt-3 pb-0 pb-md-5"
          id="hr-lines"
        >
          <div className="container pb-3">
            <div className="row">
              <div className="col-md-12 right-sp-1">
                <div className="news_section">
                  <div className="row">
                    <MobileView className={styles.MobileView}>
                      <Slider {...mobileSettings}>
                        {this.state.newsEventData.length > 0 ? (
                          this.state.newsEventData.map(
                            (newsevent_data, index) => {
                              let news = newsevent_data.news_events_tag
                                ? newsevent_data.news_events_tag
                                : "Not found";
                              // console.log(newsevent_data.department_mave.department_name,"news")
                              let news_events_title =
                                newsevent_data.news_events_title;
                              let new_news_events_title =
                                news_events_title.replaceAll(" ", "-");
                              // console.log(this.state.newsEventData)
                              return (
                                <div
                                  className="col-sm-3 post-slide"
                                  style={{ position: "relative" }}
                                  key={index}
                                >
                                  <a
                                    href={"/news/" + newsevent_data.Slug}
                                    style={{
                                      textDecoration: "none",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="news-part"
                                      style={{
                                        paddingLeft: "0px",
                                        paddingRight: "0px",
                                        width: "100%",
                                      }}
                                    >
                                      <img
                                        src={
                                          newsevent_data.news_events_pic
                                            ? IMAGE_URL +
                                              "NewsEventsImg/" +
                                              newsevent_data.news_events_pic
                                            : news_events_1
                                        }
                                        style={{
                                          borderRadius: "5px",
                                          objectFit: "cover",
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        alt="news_events_1"
                                      />
                                      <div
                                        className="bg-color-back"
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                      >
                                        <div
                                          className="div"
                                          style={{
                                            width: "100%",
                                          }}
                                        >
                                          <h5
                                            style={{
                                              position: "absolute",
                                              top: 25,
                                              left: 15,
                                              backgroundColor:
                                                "rgb(158 136 89 / 60%)",
                                              borderRadius: "4px",
                                              color: "#fff",
                                              padding: "5px",
                                              fontSize: "20px",
                                              width: "30%",
                                            }}
                                          >
                                            {/* {newsevent_data.published_date} */}
                                            {this.formatDate(
                                              newsevent_data.news_events_date
                                            ).date &&
                                            this.formatDate(
                                              newsevent_data.news_events_date
                                            ).date !== NaN
                                              ? this.formatDate(
                                                  newsevent_data.news_events_date
                                                ).date + " "
                                              : "Date not found"}
                                            {/* {this.formatDate(
                                              newsevent_data.news_events_date
                                            ).year !== "undefined NaN"
                                              ? this.formatDate(
                                                  newsevent_data.news_events_date
                                                ).year
                                              : ""} */}
                                          </h5>
                                          <h5
                                            style={{
                                              position: "absolute",
                                              top: 30,
                                              right: 30,
                                              fontSize: "12px",
                                              backgroundColor:
                                                "rgb(158 136 89 / 60%)",
                                              borderRadius: "4px",
                                              color: "#fff",
                                              padding: "5px",
                                            }}
                                          >
                                            {news}
                                          </h5>
                                        </div>

                                        <p
                                          className="news_events_title"
                                          title={
                                            newsevent_data.news_events_title
                                          }
                                          style={{
                                            borderBottomRightRadius: "5px",
                                            borderBottomLeftRadius: "5px",
                                            backgroundColor: "#FFFFFF",
                                            color: "#af9763",
                                            padding: "10px",
                                            fontSize: "16px",
                                            position: "absolute",
                                            top: 160,
                                            left: -1,
                                          }}
                                        >
                                          {newsevent_data.news_events_title
                                            ? newsevent_data.news_events_title
                                                .split(" ")
                                                .slice(0, 8)
                                                .join(" ") + " ..."
                                            : ""}
                                        </p>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              );
                            }
                          )
                        ) : (
                          <div className="col-sm-12 post-slide">
                            <div className="news-part">
                              <div className="bg-color-back">
                                <p>No any news & events founds</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </Slider>
                    </MobileView>

                    <BrowserView>
                      <Slider {...settings}>
                        {this.state.newsEventData.length > 0 ? (
                          this.state.newsEventData.map(
                            (newsevent_data, index) => {
                              let news = newsevent_data.news_events_tag
                                ? newsevent_data.news_events_tag
                                : "Not found";

                              return (
                                <div
                                  className="col-sm-3 post-slide"
                                  key={index}
                                >
                                  <a
                                    href={"/news/" + newsevent_data.Slug}
                                    style={{
                                      textDecoration: "none",
                                      width: "100%",
                                    }}
                                  >
                                    <div
                                      className="news-part"
                                      style={{
                                        paddingLeft: "0px",
                                        paddingRight: "0px",
                                        width: "100%",
                                      }}
                                    >
                                      <img
                                        src={
                                          newsevent_data.news_events_pic
                                            ? IMAGE_URL +
                                              "NewsEventsImg/" +
                                              newsevent_data.news_events_pic
                                            : news_events_1
                                        }
                                        style={{
                                          width: "100%",
                                          borderRadius: "5px",
                                          objectFit: "cover",
                                          height: "100%",
                                        }}
                                        alt="news_events_1"
                                      />
                                      <div
                                        className="bg-color-back"
                                        style={{
                                          width: "100%",
                                        }}
                                      >
                                        <div
                                          className="div"
                                          style={{
                                            position: "relative",
                                            width: "100%",
                                          }}
                                        >
                                          <h5
                                            style={{
                                              position: "absolute",
                                              top: "-137px",
                                              left: "15px",
                                              backgroundColor:
                                                "rgb(158 136 89 / 60%)",
                                              borderRadius: "4px",
                                              color: "#fff",
                                              padding: "5px",
                                              fontSize: "20px",
                                              width: "22%",
                                            }}
                                          >
                                            {this.formatDate(
                                              newsevent_data.news_events_date
                                            ).date &&
                                            this.formatDate(
                                              newsevent_data.news_events_date
                                            ).date !== NaN
                                              ? this.formatDate(
                                                  newsevent_data.news_events_date
                                                ).date + " "
                                              : "Date not found"}
                                          </h5>
                                          <h5
                                            style={{
                                              position: "absolute",
                                              top: "-130px",
                                              right: "15px",
                                              fontSize: "12px",
                                              backgroundColor:
                                                "rgb(158 136 89 / 60%)",
                                              borderRadius: "4px",
                                              color: "#fff",
                                              padding: "5px",
                                            }}
                                          >
                                            {news}
                                          </h5>
                                        </div>

                                        <p
                                          className="news_events_title"
                                          title={
                                            newsevent_data.news_events_title
                                          }
                                          style={{
                                            borderBottomRightRadius: "5px",
                                            borderBottomLeftRadius: "5px",
                                            color: "#af9763",
                                            fontSize: "14px",
                                          }}
                                        >
                                          {newsevent_data.news_events_title
                                            ? newsevent_data.news_events_title
                                                .split(" ")
                                                .slice(0, 10)
                                                .join(" ") + " ..."
                                            : ""}
                                        </p>
                                      </div>
                                    </div>
                                  </a>
                                </div>
                              );
                            }
                          )
                        ) : (
                          <div className="col-sm-12 post-slide">
                            <div className="news-part">
                              <div className="bg-color-back">
                                <p>No any news & events founds</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </Slider>
                    </BrowserView>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default NewsSlides;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/NewsSlides.js